import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TR } from 'src/TextRes';
import { CourseProviderEdit } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface CPBookingTermsProps {
    courseProvider: CourseProviderEdit;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    saveBookingTerms: (a: string) => void;
}

export interface CPBookingTermsState {
    bookingTerms: string;
    default: boolean;
    validationError: boolean;
}

export default class CPBookingTerms extends React.PureComponent<CPBookingTermsProps, CPBookingTermsState> {
    constructor(props: CPBookingTermsProps) {
        super(props);
        this.state = {
            bookingTerms: '',
            default: false,
            validationError: false,
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            bookingTerms: this.props.courseProvider.BookingTerms,
        });
    }

    public render() {
        const { bookingTerms } = this.state;
        return (
            <CPItemEditComponent
                name="Buchungsbedingungen"
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    if (bookingTerms.length < 3) {
                        this.setState({ validationError: true });
                    } else {
                        this.setState({ validationError: false }, () => {
                            this.props.saveBookingTerms(bookingTerms);
                        });
                    }
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={this.state.validationError}
                validationMessage={this.state.validationError ? TR.cPBookingTerms_check_data : ''}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.BookingTerms) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (!this.props.courseProvider.BookingTerms) {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.cPBookingTerms_missing_data} />
                </Col>
            );
        } else {
            return (
                <Col md={12}>
                    {this.props.courseProvider.BookingTerms && (
                        <div className="mb-1 mt-1">{this.props.courseProvider.BookingTerms}</div>
                    )}
                </Col>
            );
        }
    };

    private renderContentEdit = () => {
        const myBookingTerms =
            TR.cPBookingTerms_booking_terms_line1 +
            TR.cPBookingTerms_booking_terms_line2 +
            TR.cPBookingTerms_booking_terms_line3;

        return (
            <>
                <Col md={12}>
                    <TextareaAutosize
                        style={{
                            border: this.state.bookingTerms.length < 3 ? '1px solid red' : 'inherit',
                            maxHeight: 200,
                            minHeight: 100,
                            width: '100%',
                        }}
                        autoFocus={true}
                        id="bookingTerms"
                        name="bookingTerms"
                        placeholder={TR.cPBookingTerms_booking_terms}
                        value={this.state.bookingTerms}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                            this.setState({ bookingTerms: e.currentTarget.value });
                        }}
                    />
                    <Button
                        className="mt-2 mb-1"
                        size="sm"
                        onClick={() => {
                            this.setState({
                                bookingTerms: myBookingTerms,
                                default: true,
                            });
                        }}
                    >
                        {TR.cPBookingTerms_template}
                    </Button>
                    <br />
                    <span style={{ fontSize: '14px', color: '#666' }}>{TR.cPBookingTerms_agb_text}</span>
                </Col>
                <Modal isOpen={this.state.default}>
                    <ModalHeader>{TR.cPBookingTerms_added_template}</ModalHeader>
                    <ModalBody>
                        <div className="col-md-12">{TR.cPBookingTerms_example_agbs}</div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({ default: false, validationError: false });
                            }}
                        >
                            {TR.cPBookingTerms_ok}
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPBookingTerms.tsx